import fetchAPI from '../../../utils/fetchApi';
import { TFavoriteAd } from 'types/TFavoriteAds';

export default async function getFavorites(): Promise<TFavoriteAd[]> {
  try {
    return await fetchAPI({
      url: `/cp/api/favorites`,
      method: 'GET',
    });
  } catch {
    return [];
  }
}
